function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M894,806H249V158c0-9.113-7.387-16.5-16.5-16.5S216,148.887,216,158v648h-42c-9.113,0-16.5,7.388-16.5,16.5 S164.887,839,174,839h42v39c0,9.112,7.387,16.5,16.5,16.5S249,887.112,249,878v-39h645c9.112,0,16.5-7.388,16.5-16.5 S903.113,806,894,806z"
}), React.createElement("path", {
  d: "M407.5,746.5c27.338,0,49.5-22.162,49.5-49.5V423c0-27.338-22.162-49.5-49.5-49.5 c-27.34,0-49.5,22.162-49.5,49.5v274C358,724.338,380.16,746.5,407.5,746.5z"
}), React.createElement("path", {
  d: "M567.5,745.5c27.338,0,49.5-22.162,49.5-49.5V356c0-27.338-22.162-49.5-49.5-49.5 c-27.341,0-49.5,22.162-49.5,49.5v340C518,723.338,540.159,745.5,567.5,745.5z"
}), React.createElement("path", {
  d: "M727.5,745.5c27.338,0,49.5-22.162,49.5-49.5V244c0-27.338-22.162-49.5-49.5-49.5 c-27.341,0-49.5,22.162-49.5,49.5v452C678,723.338,700.159,745.5,727.5,745.5z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Vrstva_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1016px",
    height: "1016px",
    viewBox: "0 0 1016 1016",
    enableBackground: "new 0 0 1016 1016",
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/custom-statistiky.8121236e.svg";
export { SvgComponent as ReactComponent };